import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';

import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import HpRespEditorialModuleItem from './HpRespEditorialModuleItem';
import { trackEditorialImpressions, trackEditorialClick } from './helpers/EditorialTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

import { HpRespEditorialModule_componentModule } from './__generated__/HpRespEditorialModule_componentModule.graphql';

type Props = {
    componentModule: HpRespEditorialModule_componentModule;
    useLazyLoadImages: boolean;
};

const HpRespEditorialModule: FC<Props> = ({ componentModule, useLazyLoadImages }) => {
    const items = (componentModule?.items || []).filter(filterNulls);

    const handleInitialDisplay = ({ inViewport }: { inViewport: boolean }): void => {
        if (items && inViewport) {
            trackEditorialImpressions(items);
        }
    };

    if (!items) {
        return null;
    }
    return (
        <HpRespModuleContainerOld addTopGap>
            <SharedInViewport stopWhenInViewport onInViewportChange={handleInitialDisplay}>
                <div className="rowFlex" data-tn="editorial-wrapper">
                    {items.map((item, index) => (
                        <HpRespEditorialModuleItem
                            key={item?.cmsId || index}
                            item={item}
                            index={index}
                            useLazyLoadImages={useLazyLoadImages}
                            onClick={() => trackEditorialClick(item, index)}
                        />
                    ))}
                </div>
            </SharedInViewport>
        </HpRespModuleContainerOld>
    );
};

export default createFragmentContainer(HpRespEditorialModule, {
    componentModule: graphql`
        fragment HpRespEditorialModule_componentModule on EditorialModule {
            items {
                cmsId
                linkData {
                    # path is used in EditorialTracking.js
                    path
                }
                ...HpRespEditorialModuleItem_item
            }
        }
    `,
});
